import uiarticlebyline from './uiarticlebyline.js'

const xvnode = (ss, cfg, gr, nd, ndx, subj) => {
  const tags = cfg.h
  const { a, i, img, section, time } = tags
  const title = subj.title || subj.label
  const {
    label,
    href,
    note,
    author,
    thumbimg,
    datepublished
  } = subj

  return (
    section([
      a({ href, title }, [
        img({
          src: thumbimg,
          alt: title,
          width: 64 + 'px',
          height: 64 + 'px'
        })
      ]),
      i(note),
      a({ href, title }, label),
      uiarticlebyline(cfg, [
        author,
        time(datepublished)
      ])
    ]))
}

export default {
  type: 'uiarticleTileSuggest',
  xvnode
}
